import React from 'react';
import styled from 'styled-components';
import {
  spacer4,
  spacer64,
  gray90,
  screenXxsMax,
  spotifyGreenHighlight,
} from '@spotify-internal/encore-foundation';
import { FormattedMessage, FormattedDate, useIntl } from 'react-intl';
import { LOCALE_PREFERENCES } from '../../../lib/constants';
import { cookieSettingsStyles } from '../../Shared/CookieSettings';
import { useTrackingConsent } from '../../../lib/Tracking/useTrackingConsent';

export function Footer() {
  const intl = useIntl();
  useTrackingConsent();

  const localeLegal = LOCALE_PREFERENCES[intl.locale]
    ? LOCALE_PREFERENCES[intl.locale].languageCode
    : 'us';

  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterNav>
          <a
            href={`https://www.spotify.com/${localeLegal +
              '/'}legal/spotify-for-podcasters-platform-terms`}
          >
            <FormattedMessage
              id="navigation.terms-and-conditions"
              description="Link to the Terms and Conditions"
              defaultMessage="Terms &amp; Conditions"
            />
          </a>
          <a href={`https://www.spotify.com/${localeLegal + '/'}legal`}>
            <FormattedMessage
              id="navigation.legal"
              description="Link to Spotify's legal page"
              defaultMessage="Legal"
            />
          </a>
          <a href={`https://www.spotify.com/${localeLegal + '/'}legal/privacy-policy/`}>
            <FormattedMessage
              id="navigation.privacy"
              description="Link to Spotify's privacy page"
              defaultMessage="Privacy"
            />
          </a>
          {/* Do not remove; GTM adds cookie info here depending on users country */}
          <button id="ot-sdk-btn" className="ot-sdk-show-settings" />
        </FooterNav>
        <Copyright>
          © <FormattedDate value={new Date()} year="numeric" /> Spotify AB
        </Copyright>
      </FooterWrapper>
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  margin-top: auto;
`;

const FooterWrapper = styled.footer`
  display: flex;
  align-items: center;
  margin-top: ${spacer64};
  padding: 24px 36px;
  border-top: 1px solid ${gray90};
  font-size: 12px;
  @media (max-width: ${screenXxsMax}) {
    align-items: flex-end;
  }
`;

const FooterNav = styled.nav`
  display: flex;
  > *:not(:last-child) {
    margin-right: 28px;
  }
  @media (max-width: ${screenXxsMax}) {
    flex-direction: column;
    a {
      padding: ${spacer4} 0;
    }
    a:last-child {
      padding-bottom: 0;
    }
  }

  button#ot-sdk-btn.ot-sdk-show-settings {
    ${cookieSettingsStyles};

    text-decoration: underline;

    &:hover,
    &:focus {
      color: ${spotifyGreenHighlight};
    }
  }
`;

const Copyright = styled.div`
  margin: 0;
  margin-left: auto;
  padding: 0;
`;
